// extracted by mini-css-extract-plugin
export default {"shop":"A25na","handle":"kjE4z","checkbox":"wTq2U","name":"XfBrD"};